var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.username && _vm.user.attributes)?_c('w-profile',{staticClass:"no-header profile",attrs:{"auth":_vm.Auth,"logger":null,"user":_vm.user,"show-preview":false,"changed":_vm.changed},on:{"updated":_vm.updated,"update:changed":function($event){_vm.changed=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }